export default [
   { header: "Dashboard", grantaccess: ['all'] },
   {
      title: "Home",
      icon: "mdi-home-outline",
      to: "/dashboard",
      grantaccess: ['all'],
   },
   { header: "Membership", grantaccess: ['members'] },
   {
      title: "Information",
      icon: "mdi-account-box",
      to: "/member/info",
      grantaccess: ['members']
   },
   {
      title: "Graduate Upgrade",
      icon: "mdi-school-outline",
      to: "/member/graduate-upgrade",
      grantaccess: ['members'],
      membertypes: ['STU'],
      requireActiveMember: true
   },
   {
      title: "Corporate Upgrade",
      icon: "mdi-account-arrow-up",
      to: "/member/corporate-upgrade",
      grantaccess: ['members'],
      corporateUpgradeAccess: true
   },
   {
      title: "CPD",
      icon: "mdi-file-multiple",
      to: "/member/cpd",
      grantaccess: ['members'],
      membertypes: ['GRA', 'COR']
   },
   {
      title: "Payments",
      icon: "mdi-file-multiple",
      to: "/member/payments",
      grantaccess: ['members'],
      memberstatuses: [2, 3, 8]
   },
   { header: "MIP AGM", grantaccess: ['members'], requireActiveMember: true },
   {
      title: "Annual Reports",
      icon: "mdi-book-multiple",
      to: "/member/annualreports",
      grantaccess: ['members'],
      requireActiveMember: true
   },
   {
      title: "Resolutions",
      icon: "mdi-book-multiple",
      to: "/member/resolutions",
      grantaccess: ['members'],
      requireActiveMember: true
   },
   {
      title: "Elections",
      icon: "mdi-archive-outline",
      to: "/member/elections",
      grantaccess: ['members'],
      requireActiveMember: true,
      requireModule: "Elections",
      requireAccess: "canSeeElections"
   },
   {
      title: "Nominations",
      icon: "mdi-account-multiple-plus",
      to: "/member/nominations",
      grantaccess: ['members'],
      requireActiveMember: true,
      requireModule: "Nominations",
      requireAccess: "canSeeNominations"
   },
   // {
   //    title: "MIP AGM",
   //    icon: "mdi-archive-outline",
   //    to: "/member/mipagm",
   //    grantaccess: ['members']
   // },
   {
      title: "Statistics",
      icon: "mdi-chart-bar",
      to: "/statistics",
      grantaccess: ['sysadmins'],
   },
   { header: "Admin Content", grantaccess: ['sysadmins'] },
   {
      title: "CMS @ Home",
      icon: "mdi-file-document-multiple",
      to: "/admin/cms",
      grantaccess: ['sysadmins']
   },
   { header: "Admin Membership", grantaccess: ['sysadmins'] },
   {
      title: "Membership",
      icon: "mdi-account-multiple",
      to: "/admin/membership",
      grantaccess: ['sysadmins']
   },
   {
      title: "Payments",
      icon: "mdi-cash-multiple",
      to: "/admin/payments",
      grantaccess: ['sysadmins']
   },
   {
      title: "CPD",
      icon: "mdi-file-multiple",
      to: "/admin/cpd",
      grantaccess: ['sysadmins']
   },
   {
      title: "Graduate Applications",
      icon: "mdi-school-outline",
      to: "/admin/graduate-upgrades",
      grantaccess: ['sysadmins']
   },
   {
      title: "Corporate Applications",
      icon: "mdi-account-arrow-up",
      to: "/admin/corporate-upgrades",
      grantaccess: ['sysadmins']
   },
   { header: "Admin MIP AGM", grantaccess: ['sysadmins'] },
   {
      title: "Annual Reports",
      icon: "mdi-book-multiple",
      to: "/admin/annualreports",
      grantaccess: ['sysadmins']
   },
   {
      title: "Resolutions",
      icon: "mdi-book-multiple",
      to: "/admin/resolutions",
      grantaccess: ['sysadmins']
   },
   {
      title: "Elections",
      icon: "mdi-ballot",
      to: "/admin/elections",
      grantaccess: ['sysadmins']
   },
   {
      title: "Nominations",
      icon: "mdi-account-multiple-plus",
      to: "/admin/nominations",
      grantaccess: ['sysadmins']
   },
   {
      title: "Past Council Members",
      icon: "mdi-account-multiple",
      to: "/admin/pastcouncil",
      grantaccess: ['sysadmins']
   },
   {
      title: "Zone Definitions",
      icon: "mdi-book-multiple",
      to: "/admin/zones",
      grantaccess: ['sysadmins']
   },
   { header: "Settings", grantaccess: ['all'] },
   {
      title: "Profile",
      icon: "mdi-cog-outline",
      to: "/profile",
      grantaccess: ['all'],
   },
];
